import AppConfig, { AppConfiguration } from './AppConfig';
import getEnvironment from './getEnvironment';

interface Config extends AppConfiguration {
  ENV: string;
  AUTH_TOKEN_STORAGE_KEY: string;
  STATE: string;
  CODE_VERIFIER: string;
}

const config: Config = {
  ...AppConfig[getEnvironment() || 'local'],
  AUTH_TOKEN_STORAGE_KEY: 'one_payment_auth_token',
  STATE: 'one_payment_auth_state',
  CODE_VERIFIER: 'one_payment_auth_code_verifier',
  ENV: getEnvironment(),
};

export default config;
